<template>
  <div class="welcome-page">
    <!-- Animated background elements -->
    <div class="bg-shapes">
      <div class="shape shape-1"></div>
      <div class="shape shape-2"></div>
      <div class="shape shape-3"></div>
    </div>

    <div class="welcome-container">
      <div class="welcome-header">
        <div class="logo-wrapper">
          <div class="logo-glow"></div>
          <img src="/logo.png" alt="Peascom Caisse Manager" class="app-logo" />
        </div>
        <h1 class="app-title">
          <span class="title-text">Peascom Caisse Manager</span>
        </h1>
        <p class="app-subtitle">Application de gestion pour vendeurs</p>
        <div class="header-divider"></div>
      </div>

      <div class="welcome-features">
        <div
          class="feature-item"
          v-for="(feature, index) in features"
          :key="index"
          :style="{ animationDelay: index * 0.1 + 's' }"
        >
          <div class="feature-icon" :style="{ background: feature.gradient }">
            <i :class="feature.icon"></i>
          </div>
          <h3>{{ feature.title }}</h3>
          <p>{{ feature.description }}</p>
        </div>
      </div>

      <div class="welcome-actions">
        <button class="btn btn-primary btn-large" @click="goToLogin">
          <span>Commencer</span>
          <i class="bi bi-arrow-right"></i>
        </button>
      </div>
    </div>

    <div class="welcome-footer">
      <p>© 2025 Peascom Caisse Manager. Tous droits réservés.</p>
      <p class="footer-company">peascom.ma</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Welcome",
  data() {
    return {
      features: [
        {
          icon: "bi bi-cash-stack",
          title: "Gestion des ventes",
          description: "Créez et suivez vos ventes facilement",
          gradient: "linear-gradient(135deg, #10b981 0%, #059669 100%)",
        },
        {
          icon: "bi bi-box-seam",
          title: "Gestion des stocks",
          description: "Suivez vos stocks et inventaires en temps réel",
          gradient: "linear-gradient(135deg, #3b82f6 0%, #2563eb 100%)",
        },
        {
          icon: "bi bi-receipt-cutoff",
          title: "Commandes clients",
          description: "Gérez les commandes et les bons de charge",
          gradient: "linear-gradient(135deg, #8b5cf6 0%, #7c3aed 100%)",
        },
        {
          icon: "bi bi-wallet2",
          title: "Paiements",
          description: "Enregistrez et suivez tous les paiements",
          gradient: "linear-gradient(135deg, #f59e0b 0%, #d97706 100%)",
        },
        {
          icon: "bi bi-graph-up-arrow",
          title: "Statistiques",
          description: "Consultez vos statistiques et performances",
          gradient: "linear-gradient(135deg, #6366f1 0%, #4f46e5 100%)",
        },
        {
          icon: "bi bi-people",
          title: "Gestion clients",
          description: "Gérez votre base de données clients",
          gradient: "linear-gradient(135deg, #ec4899 0%, #db2777 100%)",
        },
      ],
    };
  },
  methods: {
    goToLogin() {
      this.$router.push({ name: "login" });
    },
  },
};
</script>

<style scoped>
.welcome-page {
  min-height: 100vh;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1.5rem;
  position: relative;
  overflow: hidden;
}

.bg-shapes {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.shape {
  position: absolute;
  border-radius: 50%;
  filter: blur(100px);
  opacity: 0.05;
  animation: float 25s ease-in-out infinite;
}

.shape-1 {
  width: 500px;
  height: 500px;
  background: #6366f1;
  top: -150px;
  left: -150px;
  animation-delay: 0s;
}

.shape-2 {
  width: 400px;
  height: 400px;
  background: #8b5cf6;
  bottom: -100px;
  right: -100px;
  animation-delay: 8s;
}

.shape-3 {
  width: 450px;
  height: 450px;
  background: #ec4899;
  top: 50%;
  right: 10%;
  animation-delay: 16s;
}

@keyframes float {
  0%,
  100% {
    transform: translate(0, 0) scale(1);
  }
  33% {
    transform: translate(40px, -40px) scale(1.1);
  }
  66% {
    transform: translate(-30px, 30px) scale(0.9);
  }
}

.welcome-container {
  max-width: 1200px;
  width: 100%;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4rem;
  position: relative;
}

.welcome-header {
  text-align: center;
  color: #1e293b;
  animation: fadeInDown 0.8s ease-out;
  margin-bottom: 0.5rem;
}

.logo-wrapper {
  margin-bottom: 2.5rem;
  display: flex;
  justify-content: center;
  position: relative;
}

.logo-glow {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 180px;
  height: 180px;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  border-radius: 50%;
  opacity: 0.1;
  animation: pulse 3s ease-in-out infinite;
  z-index: 0;
  filter: blur(20px);
}

@keyframes pulse {
  0%,
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0.1;
  }
  50% {
    transform: translate(-50%, -50%) scale(1.15);
    opacity: 0.15;
  }
}

.app-logo {
  width: 140px;
  height: 140px;
  border-radius: 28px;
  background: #ffffff;
  padding: 1.25rem;
  box-shadow: 0 20px 60px rgba(99, 102, 241, 0.15),
    0 0 0 1px rgba(99, 102, 241, 0.1);
  border: 1px solid rgba(99, 102, 241, 0.1);
  position: relative;
  z-index: 1;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.app-logo:hover {
  transform: translateY(-8px) scale(1.03);
  box-shadow: 0 30px 80px rgba(99, 102, 241, 0.2),
    0 0 0 1px rgba(99, 102, 241, 0.15);
}

.app-title {
  font-size: 3.75rem;
  font-weight: 900;
  margin: 0 0 1rem;
  letter-spacing: -0.04em;
  background: linear-gradient(135deg, #1e293b 0%, #475569 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  line-height: 1.1;
}

.app-subtitle {
  font-size: 1.35rem;
  margin: 0 0 2rem;
  color: #64748b;
  font-weight: 400;
  line-height: 1.5;
}

.header-divider {
  width: 60px;
  height: 4px;
  background: linear-gradient(90deg, transparent, #6366f1, transparent);
  margin: 0 auto;
  border-radius: 2px;
  opacity: 0.6;
}

.welcome-features {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  width: 100%;
  max-width: 1200px;
  margin-bottom: 1rem;
}

.feature-item {
  background: #ffffff;
  border-radius: 24px;
  padding: 2.5rem 2rem;
  text-align: center;
  color: #1e293b;
  border: 1px solid #e2e8f0;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.04), 0 1px 3px rgba(0, 0, 0, 0.06);
  animation: fadeInUp 0.6s ease-out both;
  position: relative;
  overflow: hidden;
}

.feature-item::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, transparent, #6366f1, transparent);
  transform: translateX(-100%);
  transition: transform 0.6s ease;
}

.feature-item:hover::before {
  transform: translateX(100%);
}

.feature-item:hover {
  transform: translateY(-8px);
  border-color: #cbd5e1;
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.08), 0 8px 16px rgba(0, 0, 0, 0.04);
}

.feature-icon {
  width: 80px;
  height: 80px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 1.75rem;
  font-size: 2.25rem;
  color: white;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
}

.feature-item:hover .feature-icon {
  transform: scale(1.1) translateY(-4px);
  box-shadow: 0 12px 32px rgba(0, 0, 0, 0.16);
}

.feature-item h3 {
  margin: 0 0 0.875rem;
  font-size: 1.35rem;
  font-weight: 700;
  color: #1e293b;
  letter-spacing: -0.02em;
}

.feature-item p {
  margin: 0;
  font-size: 0.95rem;
  color: #64748b;
  line-height: 1.6;
  font-weight: 400;
}

.welcome-actions {
  animation: fadeInUp 0.8s ease-out 0.6s both;
  margin-top: 1rem;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 0.875rem;
  padding: 1.125rem 3rem;
  border-radius: 16px;
  font-weight: 700;
  font-size: 1.15rem;
  border: none;
  cursor: pointer;
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  text-decoration: none;
  position: relative;
  overflow: hidden;
}

.btn::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
}

.btn:hover::before {
  width: 300px;
  height: 300px;
}

.btn-primary {
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%);
  color: white;
  box-shadow: 0 10px 30px rgba(99, 102, 241, 0.3),
    0 4px 12px rgba(99, 102, 241, 0.2);
  position: relative;
  z-index: 1;
}

.btn-primary:hover {
  transform: translateY(-4px);
  box-shadow: 0 20px 40px rgba(99, 102, 241, 0.35),
    0 8px 16px rgba(99, 102, 241, 0.25);
  background: linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%);
}

.btn-primary:active {
  transform: translateY(-2px);
}

.btn-large {
  padding: 1.375rem 3.5rem;
  font-size: 1.25rem;
}

.btn span,
.btn i {
  position: relative;
  z-index: 2;
}

.btn i {
  font-size: 1.4rem;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.btn:hover i {
  transform: translateX(6px);
}

.welcome-footer {
  margin-top: 3rem;
  padding-top: 2rem;
  text-align: center;
  color: #94a3b8;
  font-size: 0.9rem;
  z-index: 1;
  animation: fadeIn 1s ease-out 0.8s both;
  font-weight: 400;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.footer-company {
  color: #6366f1;
  font-weight: 600;
  font-size: 0.95rem;
  margin: 0;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (max-width: 768px) {
  .welcome-page {
    padding: 2rem 1rem;
  }

  .welcome-container {
    gap: 3rem;
  }

  .app-title {
    font-size: 2.75rem;
  }

  .app-subtitle {
    font-size: 1.15rem;
  }

  .app-logo {
    width: 120px;
    height: 120px;
  }

  .logo-glow {
    width: 150px;
    height: 150px;
  }

  .welcome-features {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }

  .feature-item {
    padding: 2rem 1.75rem;
  }

  .feature-icon {
    width: 70px;
    height: 70px;
    font-size: 2rem;
    margin-bottom: 1.5rem;
  }

  .btn-large {
    padding: 1.125rem 2.5rem;
    font-size: 1.1rem;
    width: 100%;
    max-width: 320px;
    justify-content: center;
  }
}

@media (max-width: 480px) {
  .welcome-page {
    padding: 1.5rem 1rem;
  }

  .welcome-container {
    gap: 2.5rem;
  }

  .app-title {
    font-size: 2.25rem;
  }

  .app-subtitle {
    font-size: 1rem;
  }

  .app-logo {
    width: 100px;
    height: 100px;
    padding: 1rem;
  }

  .logo-glow {
    width: 130px;
    height: 130px;
  }

  .feature-item {
    padding: 1.75rem 1.5rem;
  }

  .feature-icon {
    width: 65px;
    height: 65px;
    font-size: 1.875rem;
    margin-bottom: 1.25rem;
  }

  .feature-item h3 {
    font-size: 1.2rem;
  }

  .feature-item p {
    font-size: 0.875rem;
  }

  .btn-large {
    padding: 1rem 2rem;
    font-size: 1rem;
  }
}
</style>
